import { render, staticRenderFns } from "./my-withdraw.vue?vue&type=template&id=460aa0ba&scoped=true&"
import script from "./my-withdraw.vue?vue&type=script&lang=js&"
export * from "./my-withdraw.vue?vue&type=script&lang=js&"
import style0 from "./my-withdraw.vue?vue&type=style&index=0&id=460aa0ba&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "460aa0ba",
  null
  
)

export default component.exports